import { copApi } from 'api'

export interface Skill {
  id: string
  name: string
  color?: string
  picture?: string
  order?: number
  priority?: number
  hoverText?: string
  capColor?: string
  capabilities?: unknown[]
}
export const fetchSkills = () => copApi.get<Skill[]>('/digital-profile/high-level/skills')
